<rt-dialog-header
  [heading]="'tlc.ask_hr.form_templates.heading' | translate"
  [subheading]="'tlc.ask_hr.form_templates.subheading' | translate"
/>
<rt-dialog-body class="container">
  @for (template of predefinedTemplates(); track template.name) {
    <div class="rt-card rt-card-clickable template" (click)="openTemplateEdit(template)">
      <rt-symbol [symbol]="template.symbol" margin-bottom-small />
      <rt-heading variant="heading large" margin-bottom-small-xx>{{ template.name }}</rt-heading>
      <div
        class="description"
        prosemirrorBasicConfig
        [prosemirrorRender]="template.descriptionJson"
        [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
      ></div>
    </div>
  }
  <div class="rt-card rt-card-clickable template-custom" (click)="openTemplateEdit(null)">
    <rt-icon-container
      name="add"
      shape="squircle"
      background="colorBgSecondaryDisabled"
      color="colorIconDisabled"
      containerSize="large-xx"
      margin-bottom-small
    />
    <rt-heading variant="heading large">
      {{ 'tlc.ask_hr.form_templates.start_from_scratch' | translate }}
    </rt-heading>
  </div>
</rt-dialog-body>
